export const AVATAR_CROP_MIN = 120;
export const BANNER_CROP_MIN_WIDTH = 220;
